import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from "react";
import { useTranslations } from "next-intl";
import { IconButton, MuscleButton } from "@modules/shared/components/buttons";
import { useMediaQuery } from "react-responsive";
import { useHotelsSearch } from "@lib/context/hotels/search-context";
import { useMobileFilters } from "@lib/context/mobile/filters-context";
import APP_CONFIGURATION from "@lib/app.config";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { XMarkIcon } from "@heroicons/react/24/outline";
import HotelsOccupationsInput from "@modules/hotels/shared/inputs-bar/components/occupations-input";
import HotelsDestinationAutocompleteInput from "@modules/hotels/shared/inputs-bar/components/destination-autocomplete-input";
import MuscleCalendarDateInput from "@modules/shared/components/calendar-date-input";
import moment from "moment";
import useCssModules from "@lib/hooks/use-css-modules";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { encodeObjectToQueryString } from "@lib/util/object-ops";
export const EditHotelSelection = () => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2, _search$dates, _search$dates2;
  const t = useTranslations("Hotels");
  const router = useMuscleRouter();
  const {
    search,
    setSearch,
    setDestinationSelection,
    destinationSelection
  } = useHotelsSearch();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    setNode
  } = useForwardNode();
  const {
    hotelsFilters
  } = useMobileFilters();
  const isMobile = useMediaQuery({
    maxWidth: (_APP_CONFIGURATION$co = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.md) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : 767
  });
  const {
    cssModules
  } = useCssModules();
  const {
    editHotelSelectionPanelContainer,
    editHotelSelectionHeaderContainer,
    editHotelSelectionTitle,
    editHotelSelectionApplyButtonContainer,
    editHotelSelectionInputsContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.EditHotelSelection) || {};
  const {
    exitIconClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.sideOverPanel) || {};
  const handleDestinationChange = autocompleteOption => {
    if (!search || !autocompleteOption) return;
    const updatedDestination = {
      id: autocompleteOption.id,
      value: autocompleteOption.title
    };
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      destination: updatedDestination
    }));
    setDestinationSelection(autocompleteOption);
  };
  const handleDateChange = _ref => {
    let {
      from,
      to
    } = _ref;
    if (!search || !from || !to) return;
    const updatedDates = {
      check_in: from,
      check_out: to
    };
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      dates: updatedDates
    }));
  };
  const handleOccupationsChange = occupations => {
    if (!search) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      occupations
    }));
    hotelsFilters.setSelectedOccupations(occupations);
  };
  const handleSearch = () => {
    router.push("/hotels/search", {
      search: encodeObjectToQueryString(search)
    });
    togglePanel();
  };
  const handleOccupationsClick = () => {
    setNode("GuestSelection");
  };

  // Sync destinationSelection with search when it changes
  useEffect(() => {
    if (destinationSelection && search) {
      var _search$destination;
      const currentDestination = destinationSelection.value;
      if (((_search$destination = search.destination) === null || _search$destination === void 0 ? void 0 : _search$destination.id) !== (currentDestination === null || currentDestination === void 0 ? void 0 : currentDestination.id)) {
        setSearch(_objectSpread(_objectSpread({}, search), {}, {
          destination: currentDestination
        }));
      }
    }
  }, [destinationSelection, search, setSearch]);
  return __jsx("div", {
    className: editHotelSelectionPanelContainer
  }, __jsx("div", {
    className: editHotelSelectionHeaderContainer
  }, __jsx(IconButton, {
    icon: __jsx(XMarkIcon, {
      className: exitIconClassName,
      "aria-hidden": "true"
    }),
    onClickButton: () => togglePanel()
  }), __jsx("h2", {
    className: editHotelSelectionTitle
  }, t("EDIT_SEARCH"))), __jsx("div", {
    className: editHotelSelectionInputsContainer
  }, __jsx("div", {
    onClick: handleOccupationsClick,
    className: "w-fit"
  }, __jsx(HotelsOccupationsInput, {
    selectedOccupations: hotelsFilters.selectedOccupations,
    setSelectedOccupations: handleOccupationsChange
  })), __jsx(HotelsDestinationAutocompleteInput, {
    onClick: () => {
      setNode("HotelsDestinationSelection");
    },
    dataTestId: "hotels-search-destination-input-edit",
    onSelectOption: handleDestinationChange,
    value: destinationSelection === null || destinationSelection === void 0 ? void 0 : destinationSelection.value,
    disablePopper: isMobile,
    disableLabelAnimation: true
  }), __jsx(MuscleCalendarDateInput, {
    onClick: () => {
      setNode("HotelsCalendarSelection");
    },
    dataTestId: "hotels-search-calendar-input-edit",
    customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
    label: t("InputsBar.CHECK_IN_CHECK_OUT"),
    maxDate: moment().startOf("day").add(365, "days").toDate(),
    value: [search !== null && search !== void 0 && (_search$dates = search.dates) !== null && _search$dates !== void 0 && _search$dates.check_in ? new Date(search.dates.check_in) : undefined, search !== null && search !== void 0 && (_search$dates2 = search.dates) !== null && _search$dates2 !== void 0 && _search$dates2.check_out ? new Date(search.dates.check_out) : undefined],
    onChangeValue: handleDateChange,
    applyImmediate: true,
    dateRangeMode: true,
    hideLabel: true
  })), __jsx("div", {
    className: editHotelSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    dataTestId: "mobile-hotels-search-button",
    variant: "solidXL",
    onClick: handleSearch
  }, t("UPDATE_SEARCH"))));
};